<template>
  <div id="app">
    <router-view></router-view>
    <back-button></back-button>
    <home-button></home-button>
  </div>
</template>

<script>
  import BackButton from '@/components/BackButton.vue'
  import HomeButton from "@/components/HomeButton.vue";

  export default  {
    components: {
      BackButton,
      HomeButton,
    },
    name: 'App'
  }
</script>

<style lang="scss">
@import 'assets/styles/main';
@import 'assets/styles/landing';
@import 'assets/styles/pubic-transport';
@import 'assets/styles/explore';
@import 'assets/styles/forecast';
@import 'assets/styles/maintenance';
</style>
